'use strict';

function slickCarouselFunction(g) {
  function init() {
    $('.carousel').slick({
      appendArrows: $('.bloc-actus__arrows'),
      prevArrow: $('.btn--carousel-prev'),
      nextArrow: $('.btn--carousel-next'),
      infinite: false,
      slidesToShow: 3,
      slidesToScroll: 1,
      responsive: [
        {
          breakpoint: 1000,
          settings: {
            slidesToShow: 3
          }
        },
        {
          breakpoint: 768,
          settings: {
            slidesToShow: 2,
            variableWidth: true
          }
        },
        {
          breakpoint: 550,
          settings: {
            slidesToShow: 1,
            variableWidth: true
          }
        }
      ]
    });
  }

  init();
}
